module.exports = __webpack_public_path__ + "static/media/pngtree-user-vector-avatar-png-image_1541962 (1).775b91d4.jpg";